import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    newLines: {
        '& > p': {
            'white-space': 'pre',
        },
    },
}));